import React from 'react';
import { useTranslation } from 'react-i18next';
import HardwareSignupCard from '../../../HardwareSignupCard/HardwareSignupCard';
import currencies from '../../../../../../constants/CurrencyTypes';
import { formatNumberOnLocale, getPlanTranslation } from '../../../../../../constants/AppMethod';

const DisplayMonthlyPageAllowance = (props) => {
    const { handleSelectionChange, selectedData, servicePlans } = props

    const { t } = useTranslation(["translation"])

    return (
        <div className='cp-printer-feature-wrapper'>
            <div className='cp-subtitle'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.SUPPLY_PLAN.HEADER")}</div>

            <div className='cp-subsection-title'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.SUPPLY_PLAN.SUB_HEADER")}</div>

            <div className='cp-card'>
                {servicePlans?.map(plan => (
                    <HardwareSignupCard
                        id={plan.planId}
                        onHardwarePlanSelection={handleSelectionChange}
                        selectedCard={selectedData?.planPages}
                        toCompareSelectedCardWith={plan?.planPages}
                        cardRightData={`${getPlanTranslation(plan.planName)} - ${t('ECOPROCAROUSEL_CONTENT.NO_OF_PAGES', { planPages: plan.planPages })}`}
                        cardLeftData={`${formatNumberOnLocale(plan?.price, currencies[plan.currency]?.code)} ${t('HARDWARE_SIGNUP.GENERIC.PER_PM')}`}
                        selectionPayload={plan}
                    ></HardwareSignupCard>
                ))}
            </div>
        </div>
    );
};

export default DisplayMonthlyPageAllowance;